import { useMemo } from "react"
import { Link, Stack } from "@mui/material"
import { useAtom, useSetAtom } from "jotai"
import { appDevelopingModalPopupState } from "@/atoms/appPopupState"
import { restakingBalancesAtom } from "@/atoms/restakingState"
import { tokenDecimalDigits, TokenSymbol } from "@/utils/helpers"
import { VE_REL } from "@/utils/constants"
import { formatToken } from "@/utils/numberFormatter"

import ItemInfo from "../../shared/ItemInfo"
import useTrans from "@/hooks/useTrans"
import useRestaking from "@/hooks/useRestaking"

const Convert = () => {
  const trans = useTrans()
  const { rewardItemInfo } = useRestaking()
  // atoms
  const setDevelopingPopupState = useSetAtom(appDevelopingModalPopupState)
  const [restakingBalances] = useAtom(restakingBalancesAtom)

  const handleOpenDevelopingModal = () => {
    setDevelopingPopupState({
      isOpen: true,
    })
  }

  const rewardTokenDisplay = useMemo(() => {
    if (!restakingBalances.rewardToken) return "0"

    return formatToken(
      restakingBalances.rewardToken,
      tokenDecimalDigits[(rewardItemInfo?.symbol as TokenSymbol) ?? VE_REL],
      false,
      false,
      undefined,
      false,
      {},
    )
  }, [restakingBalances.rewardToken, rewardItemInfo?.symbol])

  return (
    <Stack gap={1} data-testid='staking-detail-convert'>
      <Stack direction='row' justifyContent='space-between' alignItems='start' gap={1}>
        <ItemInfo title={trans.staking.detail.your_verel} value={rewardTokenDisplay} />

        <Link
          data-testid='restaking-convert-button'
          className='w-28 text-right text-sm font-bold text-primary hover:text-primary/80 cursor-pointer'
          onClick={handleOpenDevelopingModal}
        >
          {trans.staking.detail.convert}
        </Link>
      </Stack>
    </Stack>
  )
}

export default Convert
